import { useMutation } from '@apollo/client';
import { graphql } from '../gql';

const REFRESH_ACCESS_TOKEN = graphql(`
  mutation refreshAccessToken($refreshToken: String!) {
    refreshAccessToken(refreshToken: $refreshToken) {
      user {
        uuid
        username
        userId
        authScope
        authUsername
        authClientId
        createdAt
        updatedAt
      }
      idToken
      accessToken
      refreshToken
      expiresInSec
      expiresEpoch
      tokenType
    }
  }
`);

export function useRefreshAccessTokenMutation() {
  const [refreshAccessToken, { loading, error, reset }] =
    useMutation(REFRESH_ACCESS_TOKEN);

  return {
    refreshAccessToken,
    loading,
    error,
    reset,
  };
}
